<template>
  <!--HOMEPAGE NO ORDERS: Story CD-9 -->
  <div class="flex items-center justify-center bg-white px-4">
    <div class="w-full max-w-md text-center">
      <h2 class="text-[22px] font-semibold text-grey-light-400">No Active Orders Found on this Account</h2>

      <p class="mt-2 text-[14px] text-grey-light-400">Place an order and view recent orders here</p>

      <div class="mt-6 flex flex-col gap-3 sm:flex-row sm:justify-center sm:gap-4">
        <Button
          variant="outline"
          @click="navigate('shopperLayBy')"
          class="w-full text-[14px] justify-center text-grey-light-400 transition hover:bg-brand-50 hover:border-brand-300 hover:text-brand-800 sm:w-auto h-[40px]"
        >
          <Plus />
          Start Lay-by
        </Button>

        <Button
          variant="outline"
          @click="navigate('shopperBoostsRewards')"
          class="w-full text-[14px] justify-center text-grey-light-400 transition hover:bg-brand-50 hover:border-brand-300 hover:text-brand-800 sm:w-auto h-[40px]"
        >
          <Plus />
          Start BOOST Rewards
        </Button>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { Button } from '@/components/ui/button';
import { Plus } from 'lucide-vue-next';
import { useRouter } from 'vue-router';

const router = useRouter();

const navigate = (page: string) => router.push({ name: page });
</script>
